import { EffectCoverflow, EffectFade, Navigation, Scrollbar, Swiper } from 'swiper';
import bootbox from 'bootbox';

import { $Elements, BrowserEvents, Classes, TransitionDurations } from './constants';

Swiper.use([EffectCoverflow, EffectFade, Navigation, Scrollbar]);

;(function($) {

	$Elements.document.on(BrowserEvents.page.enter, () => {

		// ---------- Slideshows ----------

		$('.content-section:not(.horizontal-text-images-section):not(.vertical-text-images-section):not(.dates-section)').each(function() {

			$(this).find('.section-slideshow, .column-slideshow').each(function() {

				if(!this.swiper) {

					const swiper = new Swiper(this, {
						speed: TransitionDurations.page,
						loop: true,
						observer: true,
						effect: 'fade',
						fadeEffect: {
							crossFade: true
						},
						pagination: {
							el: this.querySelector('.swiper-pagination'),
						},
						navigation: {
							nextEl: this.querySelector('.swiper-button-next'),
							prevEl: this.querySelector('.swiper-button-prev'),
						},
					});
				}
			});
		});

		// ---------- Shop ----------

		$('.featured-products-section').each(function() {

			$(this).find('.section-carousel').each(function() {

				if(!this.swiper) {

					const swiper = new Swiper(this, {
						speed: TransitionDurations.page,
						loop: true,
						observer: true,
						navigation: {
							nextEl: this.querySelector('.swiper-button-next'),
							prevEl: this.querySelector('.swiper-button-prev'),
						},
					});
				}
			});
		});

		// ---------- Sections ----------

		$('.news-carousel-section').each(function() {

			const carousel = this.querySelector('.swiper-container');
			const navigation = this.querySelector('.swiper-navigation');

			if(carousel && !carousel.swiper) {

				const swiper = new Swiper(carousel, {
					speed: TransitionDurations.page,
					observer: true,
					slideToClickedSlide: true,
					slidesPerView: 'auto',
					navigation: {
						nextEl: navigation.querySelector('.swiper-button-next'),
						prevEl: navigation.querySelector('.swiper-button-prev'),
					},
				});
			}
		});

		// ---------- Next Pages ----------

		$('.next-pages-section').each((i, e) => {

			const links = $(e).find('a[data-page]');
			const images = $(e).find('.images .image');

			links.on('mouseenter touchstart', function() {
				links.removeClass(Classes.active);
				images.removeClass(Classes.active);
				$([this, images.get(parseInt(this.dataset.page, 10))]).addClass(Classes.active);
			});

			links.first().trigger('mouseenter');
		});

		// ---------- Modal Add to cart ----------

		$Elements.body.on('adding_to_cart', function(e, button, cart) {

			$Elements.LoadingBar.addClass(Classes.loading);

			$Elements.body.one('added_to_cart', () => {

				$Elements.LoadingBar.removeClass(Classes.loading);

				if(typeof added_to_cart_modal !== 'undefined') {

					bootbox.dialog({
						centerVertical: true,
						className: 'cart-modal',
						closeButton: false,
						message: added_to_cart_modal.content,
					});
				}

				if(cart.length) {
					const quantity = cart.find(item => item.name === 'quantity');

					if(quantity) {
						const link = $('.shop-links #header-cart-count');
						const current = parseInt(link.text());
						link.text(current + parseInt(quantity.value));
					}
				}
			});
		});

	});

}(jQuery));
